var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-mastercard',
                        view: publicPath + 'sprite.svg#view-icon-mastercard',
                        viewBox: '0 0 95 18',
                        title: 'Icon / Mastercard',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };